import { HTMLAttributes, ReactNode } from 'react';
import { joinClassNames } from '../../utils';
import styles from './styles.module.scss';
import { HelpIcon } from '../Graphics/Icons/HelpIcon';
import { E1Link } from '../E1Link';

type LinkData = {
  url: string;
  linkText: string;
};

export type HintCardProps = HTMLAttributes<HTMLDivElement> & {
  heading: string;
  linkData?: LinkData;
  children: ReactNode;
};

export const HintCard = ({ heading, linkData, children, className, ...props }: HintCardProps) => (
  <div className={joinClassNames(styles.hintCard, className)} {...props}>
    <div className={styles.heading}>
      <HelpIcon />
      <p>
        <strong>{heading}</strong>
      </p>
    </div>
    <div className={styles.description}>{children}</div>
    {linkData && (
      <div className={styles.moreInfoLink}>
        <E1Link link={linkData.url}>{linkData.linkText}</E1Link>
      </div>
    )}
  </div>
);

HintCard.displayName = 'HintCard';
